/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_Save_BtnInputs */

const vi_combo_recipe_save_btn = /** @type {(inputs: Combo_Recipe_Save_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu công thức`)
};

/**

* @param {Combo_Recipe_Save_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_save_btn = /** @type {((inputs?: Combo_Recipe_Save_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_Save_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_save_btn(inputs)
});